import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()
export class TokenCookieService {
    constructor(private localStorageService: LocalStorageService) { }

    setTokenCookie() {
        let token = this.localStorageService.get('access_token');
        let d: Date = new Date();
        d.setTime(d.getTime() + 10 * 60 * 1000);
        let expires = `expires=${d.toUTCString()}`;
        document.cookie = `PHPACCESSTOKEN=${token}; ${expires}; path=/`;
    }
}
